<tt-page *ngIf="!!setting">
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <tt-textarea ttLabel="custactinfotext" [ttModel]="setting.custactinfotext" ttReadonly></tt-textarea>
            <tt-button-goto ttText="add_new_item" ttGoto="custactwork" [ttGotoParms]="{ custact_no: setting.custact_no, custactwork_keyno: '0' }" ttIcon="far fa-plus"></tt-button-goto>
        </tt-card>

        <tt-list-legacy [listItems]="itemsListJobs" ltype="multi" typevar="g"></tt-list-legacy>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-divider ttRememberId="custactworks_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="30">
                    <tt-card>
                        <tt-textarea ttLabel="custactinfotext" [ttModel]="setting.custactinfotext" ttReadonly></tt-textarea>
                        <tt-button-goto ttText="add_new_item" ttGoto="custactwork" [ttGotoParms]="{ custact_no: setting.custact_no, custactwork_keyno: '0' }" ttIcon="far fa-plus"></tt-button-goto>
                    </tt-card>
                </tt-divider-pane>

                <tt-divider-pane ttSize="70">
                    <tt-list-legacy [listItems]="itemsListJobs" ltype="multi" typevar="g"></tt-list-legacy>
                </tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
    </div>
</tt-page>
